import script from "./TopNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNav.vue?vue&type=script&lang=ts&setup=true"

import "./TopNav.vue?vue&type=style&index=0&id=ba0323aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0323aa"]])

export default __exports__